import { PropsWithChildren, useEffect } from "react";
import { useAccount, useSwitchChain } from "wagmi";
import { Button } from "../Actions";

const ChangeChainButton: React.FC<{ requiredChainId: number }> = ({
  requiredChainId
}) => {
  const { switchChain } = useSwitchChain();

  return (
    <Button
      suppressHydrationWarning
      modifier="primary"
      analyticsProperty="Change network"
      onClick={() => {
        switchChain && switchChain({ chainId: requiredChainId });
      }}
      type="button">
      Wrong network
    </Button>
  );
};

export default ChangeChainButton;

export const WrapMintButtonWithChangeChain: React.FC<
  PropsWithChildren<{ requiredChainId?: number }>
> = ({ children, requiredChainId = 1 }) => {
  const { chain } = useAccount();

  if (chain?.id !== requiredChainId) {
    return <ChangeChainButton requiredChainId={requiredChainId} />;
  }
  return <>{children}</>;
};
